import React from "react"

import Video from "./_base/Video"

import * as newsStyles from "../styles/News.module.css"

import WPCta from "./_base/WPCta"

import { ChildSelector } from "../helpers/ChildSelector"

const promotionalVideo = content => {
  const videoNodes = content.childNodes.filter(node =>
    node.classNames.trim().split(/\s+/).includes("cw-external-video")
  )
  if (!videoNodes) return null

  const videoNode = videoNodes[0]
  if (!videoNode) return null

  if (!videoNode.childNodes || !videoNode.childNodes[0]) return null

  const videoLink =
    (videoNode.childNodes[0].attrs && videoNode.childNodes[0].attrs.href) ||
    null

  return videoLink
}

export default function News(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `news-title`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const textStack = content.childNodes
    .filter(node => node.classNames === "news-content")
    .map(t => t.text)

  const videoLink = promotionalVideo(content)

  return (
    <>
      <div className={`row justify-content-center ${newsStyles.wrapper}`}>
        <div className={`col-12 ${newsStyles.content}`}>
          <h4
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
          {textStack.map((t, idx) => (
            <p key={idx}>{t}</p>
          ))}
        </div>
        <div className={`col-12 ${newsStyles.ctaWrapper}`}>
          <WPCta
            holder={content}
            selector={`news-cta`}
            pageContext={props.pageContext}
            modals={props.modals}
            translate={false}
            className={`${newsStyles.cta}`}
          />
          {videoLink && <Video videoSrcURL={videoLink} videoTitle={title} />}
        </div>
      </div>
    </>
  )
}
